/** Client activity + status — isolated from buyer/seller checklist state. */

import { getById, listTable, updateRow, writeAudit } from "../db";

const KEY = "dh_client_activity";

export const CLIENT_STATUS = {
  active: "active",
  suspended: "suspended",
  completed: "completed",
  archived: "archived",
};

export function clientStatusLabel(status) {
  if (status === "suspended") return "Suspended";
  if (status === "completed") return "Completed";
  if (status === "archived") return "Archived";
  return "Active";
}

function readAll() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "{}");
  } catch {
    return {};
  }
}

function writeAll(map) {
  localStorage.setItem(KEY, JSON.stringify(map));
}

export function logClientActivity(clientId, action, metadata = {}) {
  if (!clientId) return;
  const all = readAll();
  const row = {
    id: crypto.randomUUID(),
    at: new Date().toISOString(),
    action,
    metadata,
  };
  all[clientId] = [row, ...(all[clientId] || [])].slice(0, 60);
  writeAll(all);
  try {
    writeAudit({
      user_id: metadata.actorId || null,
      action_type: `client.${action}`,
      transaction_id: metadata.transactionId || null,
      metadata: { client_id: clientId, ...metadata },
    });
  } catch {
    /* ignore */
  }
  return row;
}

export function listClientActivity(clientId) {
  return readAll()[clientId] || [];
}

export function lastClientActivity(clientId) {
  return listClientActivity(clientId)[0] || null;
}

export function setClientStatus(clientId, status, actor) {
  const allowed = Object.values(CLIENT_STATUS);
  if (!allowed.includes(status)) throw new Error("Unknown client status.");
  const user = updateRow("users", clientId, { status });
  logClientActivity(clientId, "status", { status, actorId: actor?.userId || null });
  return user;
}

export function assignedAgentOptions(session) {
  if (!session?.userId) return [];
  if (session.role === "agent") {
    return [{ id: session.userId, name: session.name || "You" }];
  }
  return listTable("users")
    .filter((user) => user.role_type === "agent" && user.brokerage_id === session.userId)
    .map((user) => ({ id: user.id, name: user.name || user.email }));
}

export function clientKindLabel(client) {
  return client?.role_type === "seller" ? "Seller" : "Buyer";
}

export function getClientRecord(clientId) {
  return getById("users", clientId);
}
